import './App.css';
import AppRouter from './routers/AppRouter';
import { SnackbarProvider } from 'notistack';
import Slide from '@mui/material/Slide';
import { useFavicon } from './components/hooks/useFavicon';

function App() {
  useFavicon();
  return (
      <SnackbarProvider maxSnack={3}
          autoHideDuration={2000}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
        }}
        TransitionComponent={Slide}>
          <AppRouter />
      </SnackbarProvider>
  );
}

export default App;
